import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    sessionStorage.getItem("CashPayment_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   
    
	
	
   if(sessionStorage.getItem("CashPayment_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    document.getElementById("txtVNo").value="{Auto}";
    document.getElementById("txtBillDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("CashPayment_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("CashPayment_EditId"));
   }
   else if(sessionStorage.getItem("CashPayment_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("CashPayment_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  }

  const [isDisabled, setisDisabled]=useState(false);

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  


  const [dtPaidFrom, setdtPaidFrom]=useState([]);
  const [dtPaidTo, setdtPaidTo]=useState([]);
  const [dtMetal, setdtMetal]=useState([]);
  const [dtPayMode, setdtPayMode]=useState([]);
 
  const [btndisabled, setDisabled] = useState('disabled');


  const [FromCode, setFromCode, FromCodeRef] = useStateRef();
  const [ToCode, setToCode, ToCodeRef] = useStateRef();
  const [MetalCode, setMetalCode, MetalCodeRef] = useStateRef();
  const [PayMode, setPayMode, PayModeRef] = useStateRef();
 
 
  async function Clear()
   {
        

		handleClose1();
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



function Calc()
{
  document.getElementById("txtValue").value=parseFloat(val(document.getElementById("txtRate").value)*val(document.getElementById("txtWeight").value)).toFixed(2);

  

}

async function ControlSettings()
{

  document.getElementById("txtVNo").disabled ='true';
  document.getElementById("txtBillDate").disabled ='true';
  
  
  if((sessionStorage.getItem("CashPayment_Action")=="Edit") || (sessionStorage.getItem("CashPayment_Action")=="Delete"))
   {
  

    

   }

 



}
async function TagPrint()
{
  try
  {
   
    let postData = {
      TagId: document.getElementById("txtVNo").value
  }

  

  const results = await apiService.postCall("cashpayment/tagprint",postData);


 if (results != "-1") {

 }
}

catch (error) {
  console.log(error);
}
}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("cashpayment/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   

   getLookup();
   
   document.getElementById("txtVNo").value=HeadData[0][0].VNo;
      document.getElementById("txtBillDate").value=HeadData[0][0].BillDate.substring(0,10);
			setFromCode(HeadData[0][0].AccCode);
      setToCode(HeadData[0][0].SubCode);
      setMetalCode(HeadData[0][0].MetalCode);
      setPayMode(HeadData[0][0].CashType);

      document.getElementById("txtBillNo").value=HeadData[0][0].BillNo;
			document.getElementById("txtNarration").value=HeadData[0][0].Narration;
			document.getElementById("txtChqNo").value=HeadData[0][0].ChequeNo;
			document.getElementById("txtRate").value=HeadData[0][0].BullionRate;
      document.getElementById("txtValue").value=HeadData[0][0].Value;
      document.getElementById("txtWeight").value=HeadData[0][0].Weight;
      document.getElementById("txtChqDate").value=HeadData[0][0].ChequeDate.substring(0,10);


   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
			
			
	
		 
		let postData = {
			"Action" : sessionStorage.getItem("CashPayment_Action"),
			"EditId" : sessionStorage.getItem("CashPayment_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"BillDate": document.getElementById("txtBillDate").value,
			"FromCode": FromCodeRef.current,
      "ToCode": ToCodeRef.current,
      "MetalCode": document.getElementById("txtMetalName").value,
      "CashType": document.getElementById("txtPayMode").value,
      "BillNo": document.getElementById("txtBillNo").value,
			"Narration": document.getElementById("txtNarration").value,
			"ChqNo": document.getElementById("txtChqNo").value,
			"Rate": document.getElementById("txtRate").value,
      "Value": document.getElementById("txtValue").value,
      "Weight": document.getElementById("txtWeight").value,
      "ChqDate": document.getElementById("txtChqDate").value
      
		}
    

   const results = await apiService.postCall("cashpayment/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("CashPayment_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("CashPayment_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("CashPayment_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }









  async function getLookup(){
	 try {
		
		 
		 
		let postData = [];
		
    const results = await apiService.postCall("cashpayment/Lookup",postData);

	 if (results != "-1") {

   
			setdtPaidFrom(results.data[0][0]);
      setdtPaidTo(results.data[1][0]);
      setdtMetal(results.data[2][0]);
      setdtPayMode(results.data[3][0]);
     
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/smith/cashpayment/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Cash Payment Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Voucher No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtVNo" placeholder="" />
                          </div>
						  
						  
						          <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" />
                          </div>
						  
                          <div className='col-md-12'>
                          <Form.Label>From Name</Form.Label>


                          <Select className="" id="txtFrom" 
                             options={dtPaidFrom}
                             isDisabled={isDisabled}
                             value={dtPaidFrom.filter(function(option) {
                              return option.value === FromCode;
                            })}
                            onChange=
                            {
                              (e) => {

                                setFromCode(e.value);
                                 
                              }
                              }
                             >
              								
							               </Select>

                          </div>

                          <div className='col-md-12'>
                            <Form.Label>To Name</Form.Label>
                             <Select className="" id="txtTo" 
                             options={dtPaidTo}
                             isDisabled={isDisabled}
                             value={dtPaidTo.filter(function(option) {
                              return option.value === ToCode;
                            })}
                            onChange=
                            {
                              (e) => {
                                setToCode(e.value);
                              }
                              }
                             >
              						   </Select>
  
                          </div>

                          <div className='col-md-12'>
                            <Form.Label>Metal Name</Form.Label>
                             <select className="form-select" id="txtMetalName" onChange={(e)=>setMetalCode(e.target.value)}  value={MetalCode} disabled={false}>
              								{ 
              								dtMetal.map(
              								(item)=>(
              								<option value={item.Code}>{item.MetalName}</option>
              								)
              								)
              								}
							               </select>
                          </div>


                        </div>
                        <div className='col-md-12 py-2'>
                          <Form.Label>Pay Mode</Form.Label>
                           <select className="form-select" id="txtPayMode" onChange={(e)=>setPayMode(e.target.value)} value={PayMode} disabled={false}>
            								{ 
            								dtPayMode.map(
            								(item)=>(
            								<option value={item.PayMode}>{item.PayMode}</option>
            								)
            								)
            								}
							             </select>
                        </div>
                        

                      </div>

                    </div>

                  </div>
                 
                        
      <div className='col-lg-6'>            
                  <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                  <div className='col-md-4'>
                    <Form.Label>Bill No</Form.Label>
                    <Form.Control type="text" id="txtBillNo" placeholder=""  />
                  </div> 
                        <div className='col-md-4 '>
                    <Form.Label>Rate</Form.Label>
                    <Form.Control type="text" id="txtRate" onChange={Calc}  placeholder=""  />
                  </div> 
                        
                  <div className='col-md-4 '>
                    <Form.Label>Weight</Form.Label>
                    <Form.Control type="text" id="txtWeight" onChange={Calc} placeholder="" />
                  </div> 

                  <div className='col-md-4 '>
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="text" id="txtValue" Readonly="Readonly" placeholder="" className="txtReadOnly" />
                  </div> 

                  <div className='col-md-12 '>
                    <Form.Label>Narration</Form.Label>
                    <Form.Control type="text" id="txtNarration"  placeholder=""  />
                  </div> 

                  <div className='col-md-4 ' hidden='hidden'>
                    <Form.Label>Cheque No</Form.Label>
                    <Form.Control type="text" id="txtChqNo"  placeholder=""  />
                  </div> 

                  <div className='col-md-4 '  hidden='hidden'>
                    <Form.Label>Cheque Date</Form.Label>
                    <Form.Control type="date" id="txtChqDate"  placeholder=""  />
                  </div> 
                  

</div>
</div>     
</div>
</div>

                 
             
           
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					</Form.Group>
					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary'  onClick={TagPrint}  >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary"  disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
